import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Button, FooterActionBar } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { getMessageKey } from '../../../utils/utils';
import { COMMENT_MINIMUM_LENGTH } from '../constant';
import { BULK_ACTION_ENDDATE } from '../mockData';

function BulkActionEndDateFooter({
  handleEndDate,
  bulkActionEndDate,
  handleCloseBulkActionEndDate,
}) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);
  const submitBtnKind =
    bulkActionEndDate?.isSubmitting ||
    (bulkActionEndDate?.comment?.replace(/^\s+|\s+$/gm, '')?.length >
      COMMENT_MINIMUM_LENGTH &&
      !/<|>/.test(bulkActionEndDate?.comment) &&
      bulkActionEndDate?.endDate &&
      bulkActionEndDate?.hasAgreed)
      ? 'filled'
      : 'outlined';

  return (
    <FooterActionBar size='large'>
      <div />
      <div className='BulkActionEndDateFooter-footerButtonWrap'>
        <Button
          type='button'
          kind='ghost'
          size='medium'
          isDisabled={bulkActionEndDate?.isSubmitting}
          onClick={handleCloseBulkActionEndDate}>
          {messages['CancelLabel.ATTESTATIONS'] ||
            localize(intl, getMessageKey('CancelLabel'))}
        </Button>
        <Button
          className='BulkActionEndDateFooter-submitButton'
          classNames={{
            contentContainerClassName:
              'BulkActionEndDateFooter-submitButton--contentContainer',
          }}
          type='button'
          kind={submitBtnKind}
          size='medium'
          onClick={() =>
            handleEndDate(
              bulkActionEndDate?.id,
              bulkActionEndDate?.status,
              bulkActionEndDate?.endDate,
              bulkActionEndDate?.comment
            )
          }
          isDisabled={bulkActionEndDate?.isSubmitting}
          isLoading={bulkActionEndDate?.isSubmitting}
          loaderText={
            messages['SaveLabel.ATTESTATIONS'] ||
            localize(intl, getMessageKey('SaveLabel'))
          }>
          {messages['SaveLabel.ATTESTATIONS'] ||
            localize(intl, getMessageKey('SaveLabel'))}
        </Button>
      </div>
    </FooterActionBar>
  );
}

BulkActionEndDateFooter.propTypes = {
  handleEndDate: PropTypes.func.isRequired,
  bulkActionEndDate: PropTypes.shape(BULK_ACTION_ENDDATE).isRequired,
  handleCloseBulkActionEndDate: PropTypes.func.isRequired,
};

export default BulkActionEndDateFooter;
